export const filterPagesByType = (edges, type) => {
  const byType = type => edge =>
    edge.node.fileAbsolutePath.includes(`/${type}/`);

  return edges.filter(byType(type));
};
